/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-21T19:19:46-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-10T14:53:02-07:00
*/


import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { dimensions, spacing, box } from '../../style';

const style = StyleSheet.create({
  panel: {
    ...box,
    ...spacing.MARGIN_BOTTOM_LG,
    ...spacing.PADDING_MD,
    backgroundColor: '#FFF',

    [dimensions.SCREEN_MAX_MD]: {
      padding: 0,
      borderWidth: '0',
      boxShadow: 'none',
      ...spacing.MARGIN_BOTTOM_SM
    }
  },

  alwaysBordered: {
    [dimensions.SCREEN_MAX_MD]: {
      ...box,
      ...spacing.PADDING_MD,
    }
  },

  withHeader: {
    paddingTop: '0'
  },

  none: {
    padding: '0'
  },

  small: {
    ...spacing.PADDING_SM
  },

  large: {
    ...spacing.PADDING_LG
  }
})

const Panel = (props) => {

  const {
    withHeader,
    padding,
    extraStyles,
    alwaysBordered,
  } = props

  return (
    <div style={{...extraStyles}} className={css(
      style.panel,
      padding && style[props.padding],
      withHeader && style.withHeader,
      alwaysBordered && style.alwaysBordered
    )}>
      {props.children}
    </div>
  )
}



export default Panel;



// WEBPACK FOOTER //
// ./src/components/common/Panel.jsx